import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

// Section 02 · Produk Semen — produk picker, editable nama_barang, jumlah,
// and satuan. `onSelectProduct` is provided by the parent because it also
// auto-fills related fields (nama_barang, dsb.).
export default function ProdukSection({ form, setF, products, onSelectProduct }) {
  return (
    <div className="border border-border p-6 bg-card">
      <div className="overline mb-4">02 · Produk Semen</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label className="overline block mb-2">Produk *</Label>
          <Select value={form.produk_id} onValueChange={onSelectProduct}>
            <SelectTrigger className="rounded-lg h-11" data-testid="select-produk">
              <SelectValue placeholder="Pilih produk semen" />
            </SelectTrigger>
            <SelectContent>
              {products.map((p) => (
                <SelectItem key={p.id} value={p.id}>{p.nama}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="overline block mb-2">Nama Barang *</Label>
          <Input
            value={form.nama_barang}
            onChange={(e) => setF({ nama_barang: e.target.value })}
            className="rounded-lg h-11"
            placeholder="Otomatis dari produk, bisa diubah"
            data-testid="input-nama-barang"
          />
        </div>
        <div>
          <Label className="overline block mb-2">Jumlah *</Label>
          <Input
            type="number"
            step="0.01"
            value={form.jumlah}
            onChange={(e) => setF({ jumlah: e.target.value })}
            className="rounded-lg h-11 font-mono"
            required
            data-testid="input-jumlah"
          />
        </div>
        <div>
          <Label className="overline block mb-2">Satuan</Label>
          <Select value={form.satuan} onValueChange={(v) => setF({ satuan: v })}>
            <SelectTrigger className="rounded-lg h-11" data-testid="select-satuan">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="SAK">SAK</SelectItem>
              <SelectItem value="TON">TON</SelectItem>
              <SelectItem value="ZAK">ZAK</SelectItem>
              <SelectItem value="KG">KG</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
}
